<template>
  <div>
    <hit-miss
      :info-card="computedInfoCard"
      :data="statusCodes"
      :bar-colors="['#619AF8', '#EAC153', '#E2875A', '#DC596A']"
    />
    <div class="my-1 col-lg-12 col-12 d-flex flex-wrap px-0 mx-0">
      <div class="col-lg-6 col-md-6 col-12 pl-0">
        <request-details
          title="2xx codes"
          name="200 HTTP CODE"
          :request-info="success"
          :bar-colors="['#619AF8','#0A5CE4']"
          :request-details="successResponses"
          :time-stamps="timeStamps"
        />
      </div>
      <div class="col-lg-6 col-md-6 col-12 px-0">
        <request-details
          title="3xx codes"
          name="300  HTTP CODE"
          :request-info="redirection"
          :bar-colors="['#F3D686','#E6B633','#CC9D19']"
          :request-details="warningResponses"
          :time-stamps="timeStamps"
        />
      </div>
    </div>
    <div class="my-1 col-lg-12 col-12 d-flex flex-wrap px-0 mx-0">
      <div class="col-lg-6 col-md-6 col-12 pl-0">
        <request-details
          title="4xx codes"
          name="400 HTTP CODE"
          :request-info="clientError"
          :bar-colors="['#EBAD8E','#D96226','#AD4E1F']"
          :request-details="clientErrorResponses"
          :time-stamps="timeStamps"
        />
      </div>
      <div class="col-lg-6 col-md-6 col-12 px-0">
        <request-details
          title="5xx codes"
          name="500  HTTP CODE"
          :request-info="serverError "
          :bar-colors="['#D9263E']"
          :request-details="serverErrorResponses"
          :time-stamps="timeStamps"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HitMiss from '../widgets/HitMiss.vue'
import RequestDetails from '../widgets/RequestsDetails.vue'

export default {
  components: {
    HitMiss,
    RequestDetails,
  },
  data() {
    return {
      timeStamps: [],
      success: [
        {
          id: 1,
          elipseColor: '#619AF8',
          title: '200 code',
          size: '',
          description: 'The request was successful and the requested information was returned to the client.',
        },
        {
          id: 2,
          elipseColor: '#0A5CE4',
          title: 'Other 2xx codes',
          size: '',
          description: 'The request was successfully received, understood, and accepted. ',
        },
      ],
      redirection: [
        {
          id: 1,
          elipseColor: '#F3D686',
          title: '301 code',
          size: '',
          description: 'The requested resource has been permanently moved to a new location',
        },
        {
          id: 2,
          elipseColor: '#E6B633',
          title: '302 code',
          size: '',
          description: 'The URL has been changed temporarily. Response included a reference to the new URL.',
        },
        {
          id: 3,
          elipseColor: '#CC9D19 ',
          title: 'Other 3xx code',
          size: '',
          description: 'Further action was needed to be taken by the user agent in order to complete the request. ',
        },
      ],
      clientError: [
        {
          id: 1,
          elipseColor: '#EBAD8E',
          title: '403 code',
          size: '',
          description: 'Server understood the request, but it refuses to authorize it.',
        },
        {
          id: 2,
          elipseColor: '#D96226',
          title: '404 code',
          size: '',
          description: 'Server wasn\'t able to find the requested resource.',
        },
        {
          id: 3,
          elipseColor: '#AD4E1F',
          title: 'Other 4xx code',
          size: '',
          description: 'Request contains bad syntax or cannot be filled because of an issue on the client\'s side.',
        },
      ],
      serverError: [
        {
          id: 1,
          elipseColor: '#D9263E',
          title: '5xx codes',
          size: '',
          description: 'Server has encountered an error or is incapable of performing the request.',
        },
      ],
    }
  },
  computed: {
    statusCodesLoaded() {
      return this.$store.state.analytics.loadingStatusCodes
    },
    successResponseCalculated() {
      return this.$store.state.analytics.successResponse
    },
    warningResponseCalculated() {
      return this.$store.state.analytics.warningResponse
    },
    clientErroResponseCalculated() {
      return this.$store.state.analytics.clientErrorResponse
    },
    serverErrorResponseCalculated() {
      return this.$store.state.analytics.serverErrorResponse
    },
    statusCodes() {
      return this.$store.state.analytics.statusCodes ?? []
    },
    statusCodesDetails() {
      return this.$store.state.analytics.statusCodesDetails
    },
    computedInfoCard() {
      const infoCard = [
        {
          id: 1,
          title: 'Responses 2xx',
          description: this.successResponseCalculated.percentValue,
          elipseColor: '#619AF8',
          loading: this.statusCodesLoaded,

        },
        {
          id: 2,
          title: 'Redirects',
          description: this.warningResponseCalculated.percentValue,
          elipseColor: '#EAC153',
          loading: this.statusCodesLoaded,
        },
        {
          id: 3,
          title: 'Client Errors',
          description: this.clientErroResponseCalculated.percentValue,
          elipseColor: '#E2875A',
          loading: this.statusCodesLoaded,
        },
        {
          id: 4,
          title: 'Server Errors 5xx',
          description: this.serverErrorResponseCalculated.percentValue,
          elipseColor: '#DC596A',
          loading: this.statusCodesLoaded,
        },
        {
          id: 5,
          title: 'Total',
          description: this.formatNumberWithUnit(this.statusCodes.total),
          elipseColor: '',
          loading: this.statusCodesLoaded,
        },
      ]
      return infoCard
    },
    successResponses() {
      const names = ['200', '2xx']
      return this.extractValuesByNames(this.statusCodesDetails?.result, names)
    },
    warningResponses() {
      const names = ['301', '302', '3xx']
      return this.extractValuesByNames(this.statusCodesDetails.result, names)
    },
    clientErrorResponses() {
      const names = ['403', '404', '4xx']
      return this.extractValuesByNames(this.statusCodesDetails.result, names)
    },
    serverErrorResponses() {
      const names = ['5xx']
      return this.extractValuesByNames(this.statusCodesDetails.result, names)
    },
  },
  methods: {
    extractValuesByNames(dataArray, names) {
      return names.map(name => {
        const filteredData = dataArray?.filter(item => item?.name === name)
        const data = filteredData?.flatMap(item => item?.data.map(v => v.value)) ?? []
        if (filteredData && filteredData.length > 0 && filteredData[0].data) {
          this.timeStamps = filteredData[0].data.map(v => v.timestamp)
        } else {
          this.timeStamps = []
        }

        return {
          name,
          data,
        }
      })
    },
  },
}
</script>
